<div class="event-dashboard">
  <div class="dashboard-header">
    <h2>Event Manager's Dashboard</h2>
  </div>

  @if (statsLoading$ | async) {
    <mat-spinner diameter="40" class="card-loader"></mat-spinner>
  } @else {
    <div class="metrics-row" id="overall-summaries">
      <div class="appointment-card clickable" (click)="manageEvents()">
        <div class="card-top">
          <div class="grey round newbg">
            <mat-icon>event</mat-icon>
          </div>
        </div>
        <div class="card-middle">
          <div class="large-words">{{ totalEvents$ | async }}</div>
          <div>Total Events</div>
        </div>
      </div>

      <div class="appointment-card">
        <div class="card-top">
          <div class="grey round greenbg">
            <mat-icon>upcoming</mat-icon>
          </div>
        </div>
        <div class="card-middle">
          <div class="large-words">{{ upcomingEvents$ | async }}</div>
          <div>Upcoming</div>
        </div>
      </div>

      <div class="appointment-card">
        <div class="card-top">
          <div class="grey round purplebg">
            <mat-icon>history</mat-icon>
          </div>
        </div>
        <div class="card-middle">
          <div class="large-words">{{ pastEvents$ | async }}</div>
          <div>Past Events</div>
        </div>
      </div>

      <div class="appointment-card">
        <div class="card-top">
          <div class="grey round newbg">
            <mat-icon>corporate_fare</mat-icon>
          </div>
        </div>
        <div class="card-middle">
          <div class="large-words">{{ orgsWithEvents$ | async }}</div>
          <div>Organizations</div>
        </div>
      </div>
    </div>

    <div class="format-breakdown">
      <span class="format-chip">
        <mat-icon>videocam</mat-icon>
        {{ virtualEvents$ | async }} Virtual
      </span>
      <span class="format-chip">
        <mat-icon>location_on</mat-icon>
        {{ inPersonEvents$ | async }} In-Person
      </span>
    </div>

    <button mat-raised-button color="primary" class="create-event-btn" (click)="createEvent()">
      <mat-icon>add</mat-icon> Create Event
    </button>
  }

  <section class="event-list-section">
    <div class="list-header">
      <h3>{{ listMode === 'upcoming' ? 'Upcoming Events' : 'Past Events' }}</h3>
      <mat-button-toggle-group
        [value]="listMode"
        (change)="$event.value === 'upcoming' ? switchToUpcoming() : switchToPast()">
        <mat-button-toggle value="upcoming">Upcoming</mat-button-toggle>
        <mat-button-toggle value="past">Past</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    @if (listLoading) {
      <mat-spinner diameter="32" class="card-loader"></mat-spinner>
    } @else {
      @if (listMode === 'upcoming') {
        @if (pagedUpcoming.length > 0) {
  <div class="event-list">
    @for (ev of pagedUpcoming; track ev.id) {
      <div class="event-row clickable" (click)="viewEvent(ev)">
        <div class="event-date-badge">
          <span class="event-month">{{ ev.start | date:'MMM' }}</span>
          <span class="event-day">{{ ev.start | date:'d' }}</span>
        </div>
        <div class="event-info">
          <strong>{{ ev.title }}</strong>
          <span class="event-time">{{ ev.start | date:'shortTime' }}</span>
        </div>
        <span class="event-status-chip">Upcoming</span>
      </div>
    }
  </div>
  <div class="paginator-wrap">
    <mat-paginator
      [length]="allUpcoming.length"
      [pageSize]="upcomingPageSize"
      [pageIndex]="upcomingPageIndex"
      [pageSizeOptions]="[5, 10, 25]"
      (page)="onUpcomingPage($event)">
    </mat-paginator>
  </div>
} @else {
  <p class="empty-list">No upcoming events.</p>
}
      } @else {
        @if (pastEventsList.length > 0) {
  <div class="event-list">
    @for (ev of pastEventsList; track ev.id) {
      <div class="event-row clickable" (click)="viewEvent(ev)">
        <div class="event-date-badge">
          <span class="event-month">{{ ev.start | date:'MMM' }}</span>
          <span class="event-day">{{ ev.start | date:'d' }}</span>
        </div>
        <div class="event-info">
          <strong>{{ ev.title }}</strong>
          <span class="event-time">{{ ev.start | date:'shortTime' }}</span>
        </div>
        <span class="event-status-chip past">Past</span>
      </div>
    }
  </div>
  <div class="paginator-wrap">
    <mat-paginator
      [length]="pastTotalCount"
      [pageSize]="pastPageSize"
      [pageIndex]="pastPageIndex"
      [pageSizeOptions]="[5, 10, 25]"
      (page)="onPastPage($event)">
    </mat-paginator>
  </div>
} @else {
  <p class="empty-list">No past events.</p>
}
      }
    }
  </section>
</div>